const removeZeroAtFirst = (number: string) => {
  if (number === '0') {
    return '';
  }
  return number;
};

export default removeZeroAtFirst;
